import { FETCH_DEFAULT_SALES_TEMPLATE } from "../../constants/action.constants";

const initialState = {
  list: [],
};

const defaultSalesTemplateReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DEFAULT_SALES_TEMPLATE:
      return { list: action.payload };
    default:
      return state;
  }
};

export default defaultSalesTemplateReducer;
